// src/components/Loading.js
import React from 'react';

const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white">     
      <div className="w-16 h-16 sm:w-24 sm:h-24 lg:w-32 lg:h-32 border-4 border-[#08A3A9] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
